export default __webpack_public_path__ + "static/media/cashout-cassette-1.fac6c691.svg";